import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    maxHeight: 600,
    overflow: 'hidden',
    '&.closed': {
      display: 'none',
    },
  },
  menuList: {
    minWidth: 331,
    maxHeight: 540,
    overflowY: 'auto',
    paddingBottom: 0,
  },
  selectedMenuItem: {
    height: '40px',
    backgroundColor: `${theme.palette.background.paper} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
    '&:focus': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
  },
  subMenuItem: {
    paddingLeft: '60px',
    height: '40px',
  },
  headerMenuItem: {
    textTransform: 'capitalize',
    height: '40px',
  },
  allAccountsPadding: {
    height: '40px',
  },
  dropdownIcon: {
    marginRight: '-10px',
    padding: '6px',
  },
  dropdownIconAllAccts: {
    marginLeft: '-20px',
    marginRight: '-10px',
    padding: '6px',
  },
  numItems: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '8px',
    height: '25px !important',
    width: '25px !important',
    marginRight: 8,
  },
  innerNum: {
    color: theme.palette.text.contrastText,
    marginTop: 'auto',
    marginBottom: 'auto',
    lineHeight: '25px',
  },
  textContainer: {
    height: 24,
    maxHeight: 24,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    //  marginRight: '20px',
    alignItems: 'center',
    textAlign: 'center',
  },
  textBox: {
    marginTop: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    //  padding: '130 132 130 134',
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: 'Rubik',
    lineHeight: 1.71,
    letterSpacing: '1.25px',
    color: theme.palette.text.primary,
  },
  divider: {
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '85%',
  },
  lastDivider: {
    width: '100%',
  },
  subText: {
    color: theme.palette.text.secondary,
  },
  stickyButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    height: '60px',
    minWidth: '331px',
    width: '100%',
  },
  flexRow: {
    paddingRight: '8px',
    paddingBottom: '5px',
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  cancelButton: {
    width: '95px',
  },
  applyButton: {
    marginLeft: '10px',
    width: '109px',
  },
}));

export default useStyles;
